import { render, staticRenderFns } from "./ProdutosGrupos.vue?vue&type=template&id=5ae1b556&"
import script from "./ProdutosGrupos.vue?vue&type=script&lang=js&"
export * from "./ProdutosGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports